import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import {searchPurchaseOrders} from "./actions";

class PurchaseOrdersPage extends Component {
  static propTypes = {
    dispensaryId: PropTypes.string,
    history: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,

    searchPurchaseOrders: PropTypes.func.isRequired,
  };

  render() {
    const {
      history, searchPurchaseOrders, dispensaryId,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Supplier Name',
        dataIndex: 'supplierName',
        key: 'supplierName',
        sorter: true,
        fixed: 'left',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        sorter: true,
        filters: [
          {value: 'Draft', text: 'Draft'},
          {value: 'Sent', text: 'Sent'},
          {value: 'Ordered', text: 'Ordered'},
          {value: 'Received', text: 'Received'},
          {value: 'Cancelled', text: 'Cancelled'},
        ]
      },
      {
        title: 'Total Ordered',
        dataIndex: 'totalOrdered',
        key: 'totalOrdered',
        sorter: true,
      },
      {
        title: 'Total Ordered Cost',
        dataIndex: 'totalOrderedCost',
        key: 'totalOrderedCost',
        sorter: true,
      },
      {
        title: 'Total Received',
        dataIndex: 'totalReceived',
        key: 'totalReceived',
        sorter: true,
      },
      {
        title: 'Total Received Cost',
        dataIndex: 'totalReceivedCost',
        key: 'totalReceivedCost',
        sorter: true,
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 150,
        render: (_, {purchaseId, status}) => {
          const links = [
            <Link key="items" to={`/purchase-order/${purchaseId}`}>Items</Link>,
            ' | '
          ];
          if (['Draft', 'Sent'].indexOf(status) >= 0) {
            links.push(<Link key="submit" to={`/purchase-order/submit/${purchaseId}`}>Submit</Link>);
            links.push(' | ');
          }
          if (['Sent'].indexOf(status) >= 0) {
            links.push(<Link key="confirm" to={`/purchase-order/confirm/${purchaseId}`}>Confirm</Link>);
            links.push(' | ');
          }
          if (['Ordered'].indexOf(status) >= 0) {
            links.push(<Link key="receive" to={`/purchase-order/receive/${purchaseId}`}>Receive</Link>);
            links.push(' | ');
          }
          if (['Draft', 'Sent', 'Ordered'].indexOf(status) >= 0) {
            links.push(<Link key="cancel" to={`/purchase-order/cancel/${purchaseId}`}>Cancel</Link>);
            links.push(' | ');
          }
          links.pop();
          return links;
        }
      }
    ];
    return (
      <ListView
        dispensaryId={dispensaryId}
        title="Purchase Orders"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchPurchaseOrders}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/purchase-order/add')}
        rowKey="purchaseId"
        scroll={{x: 1200}}
      />
    );
  }
}

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  search: state.purchaseOrder.search,
});

const mapDispatchToProps = dispatch => ({
  searchPurchaseOrders: payload => (dispatch(searchPurchaseOrders(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrdersPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/PurchaseOrdersPage.js